import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './BundleDetailsModal.scss'
import Modal from '../../../../components/Modal'
import Button, { ButtonTheme } from '../../../../components/Form/Button'
import DateUtils from '../../../../utils/date'
import { DATE_FORMAT } from '../../../../constant'
import BundleReleaseModal from '../BundleReleaseModal/BundleReleaseModal'
import BundlesService from '../../services/bundles.service'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import { bundleActions } from '../../store/bundle-slice'
import FillingSpinner, { FillingSpinnerType } from '../../../../components/FillingSpinner'
import BundleLogs from '../../components/BundleLogs/BundleLogs'
import BundleSchedulesTable from '../../components/BundleSchedulesTable/BundleSchedulesTable'
import { BundleExtendedModel } from '../../../../api/bundle/models/bundle-extended.model'

const BundleDetailsModal: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [showReleaseModal, setShowReleaseModal] = React.useState(false)

  const { selectedBundle, bundleHistory } = useSelector((state: RootState) => state.bundles)

  useEffect(() => {
    if (!selectedBundle) {
      return
    }

    void BundlesService.fetchBundleHistory(selectedBundle.id)
  }, [selectedBundle])

  const closeClick = () => {
    void dispatch(bundleActions.setSelectedBundle(undefined))
  }

  const releaseAvailable = (selectedBundle: BundleExtendedModel | undefined) => {
    if (!selectedBundle) {
      return false
    }

    const { bundleSchedules } = selectedBundle

    if (!bundleSchedules || bundleSchedules.length === 0) {
      return false
    }

    return bundleSchedules.some(schedule => schedule.status === 'unassigned')
  }

  return (
    <Modal
      title={`${t('bundle.detailsTitle')}: ${selectedBundle?.id}`}
      classNameOverlay='BundleDetailsModal'
      isOpen={!!selectedBundle}
      onClose={() => void closeClick()}
      footer={
        <div className={'BundleDetailsModal__footer'}>
          <Button
            theme={ButtonTheme.BLUE}
            onClick={() => setShowReleaseModal(true)}
            disabled={!releaseAvailable(selectedBundle)}
          >
            {t('bundle.release')}
          </Button>
        </div>
      }
    >
      {selectedBundle && (
        <>
          <div className={'BundleDetailsModal__container'}>
            <div className={'BundleDetailsModal__details-container'}>
              <p>{t<string>('bundle.id')}:</p>
              <p>{selectedBundle.id}</p>
              <p>{t<string>('bundle.identifier')}:</p>
              <p>{selectedBundle.identifier ?? '-'}</p>
              <p>{t<string>('bundle.commercialName')}:</p>
              <p>{selectedBundle.commercialName}</p>
              <p>{t<string>('bundle.startDate')}:</p>
              <p>{DateUtils.parseAndFormat(selectedBundle.startDate, DATE_FORMAT)}</p>
              <p>{t<string>('bundle.endDate')}:</p>
              <p>{DateUtils.parseAndFormat(selectedBundle.endDate, DATE_FORMAT)}</p>
              <p>{t<string>('bundle.schedule')}:</p>
            </div>

            <div className={'BundleDetailsModal__bundle-container'}>
              <BundleSchedulesTable data={selectedBundle.bundleSchedules} />
            </div>

            {bundleHistory.loading ? (
              <FillingSpinner type={FillingSpinnerType.STANDARD} />
            ) : (
              <BundleLogs data={bundleHistory.data} />
            )}
          </div>
          <BundleReleaseModal
            bundle={selectedBundle}
            isModalOpen={showReleaseModal}
            setModalOpen={setShowReleaseModal}
          />
        </>
      )}
    </Modal>
  )
}

export default BundleDetailsModal
